import React, { useEffect, useState } from 'react';
import './style.scss';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import RulesBtn from '../rulesBtn';
import Logo from '../logo';
import { BRANDS, browser, IS_SERVER } from '../../../common';
import DropDownLangList from '../dropListLang';

/**
 * Компонент Header
 *
 * @component
 * @param {Object} props
 * @param {Boolean} props.hasRules Нужно ли выводить кнопку правил, true - нужно, false - не нужно
 * @param {Number} props.promoId id фрибета, по которому берутся правила (если есть кнопка правил, то обязательное поле)
 * @param {Number} props.langId id языка для правил
 * @param {String} props.title=Правила текст кнопки правил, по умолчанию
 * @param {Boolean} [props.hasLogo=true] Нужно ли выводить логотип, true - нужно, false - не нужно
 * @param {Boolean} [props.container] Класс для контейнера
 * @param {Boolean} [props.layout] Класс для контейнера
 * @param {String} [props.positionLogo=left] Расположение логотипа, left - слева, center - по центру
 * @param {JSXElement} props.pictures Картинки на заднем фоне
 * @param {JSXElement} props.children Дочерние элементы, если есть (например, кнопки "вход" / "регистрация")
 * @param {String} props.lang язык ленда
 * @returns {function} Возвращает требуемый компонент Header
 * @param {Any} props.partnerWebLink=Правила текст кнопки правил, по умолчанию
 * isLogoNameOnly...
 */

const Header = inject(
  'appStore',
  'kafkaStore',
)(
  observer(
    ({
      hasRules,
      promoId,
      langId,
      title,
      hasLogo,
      container,
      layout,
      positionLogo,
      pictures,
      children,
      id,
      headerClassName,
      lang,
      hasDropDownLangList,
      hasTextSince,
      textSinceTranslation,
      hasPartnerLogo,
      partnerLogoSrc,
      partnerWebLink,
      isLogoNameOnly,
      newYear,
      isBeton,
    }) => {
      const [emptyBlock, setEmptyBlock] = useState(false);
      const [markdown, setMarkdown] = useState('');
      const classesWrapper = classNames('header-wrapper', { container }, { layout }, markdown);

      useEffect(() => {
        if (positionLogo === 'center' && hasRules) {
          if (!hasPartnerLogo) {
            setEmptyBlock(true);
          }
          setMarkdown('containerSpaceBetween containerSpaceBetweenChildren');
        }
        if (positionLogo === 'center' && !hasRules) setMarkdown('positionLogoCenter');
        if (positionLogo === 'left' && hasRules) setMarkdown('containerSpaceBetween');
        if (positionLogo === 'left' && !hasRules) setMarkdown('positionLogoLeft');
      }, [emptyBlock, positionLogo, hasRules]);

      return (
        <header id={id} className={headerClassName}>
          <div className={classesWrapper}>
            {hasPartnerLogo && !IS_SERVER && window.innerWidth > 1024 && !browser().mobile && (
              <div className="header-wrapper__partnerLogo-wrapper">
                <a href={partnerWebLink} className="header-wrapper__partnerLogo">
                  <img className="header-wrapper__partnerLogo" src={partnerLogoSrc} alt="" />
                </a>
              </div>
            )}
            {emptyBlock && <div className="header-wrapper__empty" />}
            {hasLogo && (
              <Logo isLogoNameOnly={isLogoNameOnly} isNewYear={newYear} isBeton={isBeton} />
            )}
            {hasRules && <RulesBtn promoId={promoId} langId={langId} title={title} lang={lang} />}
            {pictures && pictures()}
            {children}
          </div>
          {hasPartnerLogo && !IS_SERVER && window.innerWidth <= 1024 && browser().mobile && (
            <div className="header-wrapper__partnerLogo-wrapper">
              <a href={partnerWebLink} className="header-wrapper__partnerLogo">
                <img className="header-wrapper__partnerLogo" src={partnerLogoSrc} alt="" />
              </a>
            </div>
          )}
          {hasTextSince && <p className="header__since">{textSinceTranslation}</p>}
          {/* <DropDownLangList/> */}
        </header>
      );
    },
  ),
);

Header.propTypes = {
  hasRules: PropTypes.bool,
  promoId: PropTypes.number,
  title: PropTypes.string,
  partnerWebLink: PropTypes.string,
  container: PropTypes.bool,
  layout: PropTypes.bool,

  hasLogo: PropTypes.bool,
  positionLogo: PropTypes.string,
};

Header.defaultProps = {
  hasLogo: true,
  positionLogo: 'left',
};

export default Header;
